import { envConfig } from '@/libs/env-config';

interface SubscriptionData {
  id: string;
  email: string;
  createdAt: string;
  status: 'active' | 'pending' | 'unsubscribed';
}

interface SubscribeResponse {
  success: boolean;
  message: string;
  data?: SubscriptionData;
}

export const subscribe = async (email: string): Promise<SubscribeResponse> => {
  try {
    const response = await fetch(`${envConfig.apiProductUrl}/newsletter/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        subscriber_email: email,
        store_id: envConfig.storeId,
        merchant_id: envConfig.newsletter.merchantId,
        opt_out: false
      })
    });

    const data = await response.json();
    
    if (!response.ok) {
      console.error(`Newsletter subscription failed: ${data.message || 'Unknown error'}`);
      return {
        success: false,
        message: data.message || 'Failed to subscribe'
      };
    }

    return {
      success: true,
      message: "Subscription successful",
      data
    };
  } catch (error) {
    console.error('Newsletter subscription error:', error);
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Failed to subscribe'
    };
  }
};